(function () {
  const root = document.querySelector("[data-fr-market-data]");
  if (!root) return;

  const prefersReduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // ---------- Expander (Why it matters) - global toggle ----------
  root.addEventListener("click", (e) => {
    const clickedBtn = e.target.closest("[data-expander-btn]");
    if (!clickedBtn) return;

    const allBtns = Array.from(root.querySelectorAll("[data-expander-btn]"));
    const allPanels = Array.from(root.querySelectorAll("[data-expander-panel]"));

    // Determine target state: if ANY are open, close all; otherwise open all
    const anyOpen = allBtns.some((b) => b.getAttribute("aria-expanded") === "true");
    const nextOpen = !anyOpen;

    allBtns.forEach((b) => b.setAttribute("aria-expanded", nextOpen ? "true" : "false"));
    allPanels.forEach((p) => (p.hidden = nextOpen ? false : true));
  });

  // ---------- Count-up formatting ----------
  const formatValue = (value, format, decimals, prefix, suffix) => {
    const d = Number.isFinite(decimals) ? decimals : 0;
    let out = value;

    if (format === "currency") {
      out = value.toLocaleString(undefined, { minimumFractionDigits: d, maximumFractionDigits: d });
      // currency symbol handled via prefix so you can do "$" or "£" easily
    } else if (format === "percent") {
      out = value.toLocaleString(undefined, { minimumFractionDigits: d, maximumFractionDigits: d });
      // percent sign handled via suffix (e.g. "%")
    } else {
      out = value.toLocaleString(undefined, { minimumFractionDigits: d, maximumFractionDigits: d });
    }

    return `${prefix || ""}${out}${suffix || ""}`;
  };

  const animateCountUp = (el) => {
    if (prefersReduced) return;

    const target = Number(el.getAttribute("data-countup-value"));
    if (!Number.isFinite(target) || target <= 0) return;

    const format = el.getAttribute("data-countup-format") || "number";
    const decimals = parseInt(el.getAttribute("data-countup-decimals") || "0", 10);
    const prefix = el.getAttribute("data-countup-prefix") || "";
    const suffix = el.getAttribute("data-countup-suffix") || "";

    const duration = 1050;
    const startTime = performance.now();

    // Start at 0, but keep integers smooth for big numbers
    const tick = (now) => {
      const t = Math.min(1, (now - startTime) / duration);
      // Ease out
      const eased = 1 - Math.pow(1 - t, 3);

      const current = target * eased;
      const value = decimals > 0
        ? parseFloat(current.toFixed(decimals))
        : Math.round(current);

      el.textContent = formatValue(value, format, decimals, prefix, suffix);

      if (t < 1) requestAnimationFrame(tick);
      else {
        const finalValue = decimals > 0
          ? parseFloat(target.toFixed(decimals))
          : Math.round(target);

        el.textContent = formatValue(finalValue, format, decimals, prefix, suffix);
      }
    };

    requestAnimationFrame(tick);
  };

  // ---------- Intersection Observer (fire once) ----------
  const cards = Array.from(root.querySelectorAll("[data-fr-market-card]"));
  const countEls = Array.from(root.querySelectorAll("[data-countup]"));

  const seen = new WeakSet();

  const activateCard = (card) => {
    card.classList.add("is-active");
    window.setTimeout(() => card.classList.remove("is-active"), 900);
  };

  const onEnter = (entry) => {
    const card = entry.target;
    if (seen.has(card)) return;
    seen.add(card);

    // Calculate index for staggered delay (e.g., 0ms, 100ms, 200ms...)
    const index = cards.indexOf(card);
    const delay = index > -1 ? index * 100 : 0;

    setTimeout(() => {
      activateCard(card);
      const el = card.querySelector("[data-countup]");
      if (el) animateCountUp(el);
    }, delay);
  };

  if ("IntersectionObserver" in window && !prefersReduced) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) onEnter(entry);
        });
      },
      { threshold: 0.35 }
    );

    cards.forEach((c) => io.observe(c));
  } else {
    // Fallback: just set final values immediately
    countEls.forEach((el) => {
      const target = Number(el.getAttribute("data-countup-value"));
      const format = el.getAttribute("data-countup-format") || "number";
      const decimals = parseInt(el.getAttribute("data-countup-decimals") || "0", 10);
      const prefix = el.getAttribute("data-countup-prefix") || "";
      const suffix = el.getAttribute("data-countup-suffix") || "";
      if (Number.isFinite(target) && target > 0) {
        el.textContent = formatValue(target, format, decimals, prefix, suffix);
      }
    });
  }
})();
